export class ForbiddenException {}